import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Paper } from '@material-ui/core';
import * as React from 'react';

interface Props {
  title: string;
  isOpen: boolean;
  handleClose?: () => void;
  handleAction?: ()=> void;
  contents: string;
};

export const BulkCodeConfirmDialog: React.FC<Props> = (prop: Props) => {
  return (
      <Dialog 
        open={prop.isOpen}
        scroll={'paper'}
        onClose={prop.handleClose}
        
        >
          <Paper style={{width: "50vh", height:"18vh", minHeight: "175px", minWidth: "400px"}}>

        <DialogTitle >{prop.title}</DialogTitle>
        <DialogContent >
          {prop.contents}
        </DialogContent>
        <DialogActions>
        {prop.handleClose? <Button onClick={prop.handleClose}>Close</Button> : <></>}
        
        {prop.handleAction? <Button onClick={prop.handleAction}>Confirm</Button> : <></>}
        
      </DialogActions>
      </Paper>

      </Dialog>
    );
}